document.addEventListener("input", (e) => {
  if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
    let oldValue = e.target.value;
    let newValue = oldValue
      .replace(/[۰-۹]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1728)) // اعداد فارسی
      .replace(/[٠-٩]/g, (d) => String.fromCharCode(d.charCodeAt(0) - 1584));

    if (newValue !== oldValue) {
      e.target.value = newValue;
      e.target.dispatchEvent(new Event("input"));
    }
  }
  
});